export default function init() {
    init_item_feature_info();
}

function init_item_feature_info() {
    $(".item_view_options__features_item_title").on("click", function (event) {
        event.preventDefault();
        let $elem = $(this);
        let $details = $elem.siblings(".item_view_options__features_item_details");
        let $checkbox = $("input[type=checkbox]", $elem);
        $details.slideToggle(200, function () {
            $checkbox.prop("checked", $details.is(":visible"));
        });
        $("input[type=checkbox]", ".item_view_options__features_item_title").not($checkbox).prop("checked", false);
        $(".item_view_options__features_item_details").not($details).hide();
    });
}
